module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=CV - Cape Verde.8fe225c9.svg";